
import PopLayout from '@xt/www/components/classhour/layout/index.vue'
import ContentEditor from '@xt/www/components/classhour/editor/index.vue'
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { dataSource_tonghaoV2, dataSource_hide_store_key } from '@xt/client/dataSource/kindred-spirit'
import { Observer } from 'mobx-vue'
import MomentCard from './components/MomentCard/index.vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import VirtualWaterfall from '@xt/www/components/virtualWaterFall/index.vue'
import { EnumGuildMemberType, EnumTongHaoStatus } from '@xt/client/enums/kindred-spirit'
import { DairyOption, HomeworkOption } from '@xt/client/entities/course-v2/user-content'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import ConfirmModal from './components/ConfirmModal/index.vue'
import CongratulateModal, { CongratulateType, type CongratulateModalData } from './components/CongratulateModal/index.vue'
import type {
  ConfirmModalOptions,
  Moment,
  ModalDataType,
  CityTypeInfo,
  GuildDetail
} from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { EnumCityStatus, EnumJoinResponseType } from '@xt/client/entities/kindred-spirit/guild'
import { Bind, Debounce } from 'lodash-decorators'
import lodash from 'lodash'
import HeaderPanel from './components/HeaderPanel/index.vue'
import IntroPanel, { EnumStatus } from './components/IntroPanel/index.vue'
import CityListGird from './components/CityListGird/index.vue'
import { checkLocationPermission, getUserLocation, type UserLocationInfo } from '@xt/client/utils/geojson'
import { MomentSourceType } from '@xt/client/enums/moment'
import { WaterfallMoment } from '@xt/client/entities/course-v2/types'

type QueryParams = {
  active: string
}

const elVisible = {
  el1: false,
  el2: false
}

@Observer
@Component({
  components: {
    MomentCard,
    InfiniteLoading,
    UserContentPop,
    VirtualWaterfall,
    ConfirmModal,
    HeaderPanel,
    IntroPanel,
    CityListGird,
    CongratulateModal,
    PopLayout,
    ContentEditor
  },
  async asyncData(ctx) {
    const queryParams = ctx.store.$tonghao.formatQuery(ctx.query)
    await ctx.store.$tonghao.loadJSON()

    let hasJoin: boolean = false
    let guildDetail: GuildDetail | null = null

    if (ctx.store.$storeUser.UserInfo.id) {
      hasJoin = await ctx.store.$tonghao.Guild.getHasJoinedCity()

      if (!hasJoin) {
        return {
          queryParams,
          hasJoin,
          isManager: false,
          guildDetail
        }
      }

      const data = await ctx.store.$tonghao.Guild.getGuildDetail(ctx.store.$tonghao.Guild.joinedCity!.id)
      if (!!data === true) {
        guildDetail = data
      }
    }

    const { memberType } = ctx.store.$tonghao.Guild.joinedCity!
    const isManager = memberType === EnumGuildMemberType.Manager

    return {
      queryParams,
      hasJoin,
      isManager,
      guildDetail
    }
  }
})
export default class TonghaoPage extends Vue {
  queryParams: QueryParams

  requestTime: number = Date.now()
  needLogin: boolean = false

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  get EnumTongHaoStatus() {
    return EnumTongHaoStatus
  }

  get bodyParams() {
    let params: string[] = []
    Object.entries(this.queryParams).forEach(([key, value]) => {
      let title: string = ''

      if (key === 'active' && value !== '') {
        title = this.tabs.filter(el => el.key === value)[0]?.title
      }

      if (title) {
        // 排除1，塞入其他选项
        // 1202 - ‘推荐’ 移除 ‘同学作品（7）’
        if (value === EnumTongHaoStatus.Discover || value === EnumTongHaoStatus.Follow) {
          params = this.tabs
            .filter(
              el =>
                !(
                  el.key === EnumTongHaoStatus.Follow ||
                  el.key === EnumTongHaoStatus.Discover ||
                  el.key === EnumTongHaoStatus.ClassmateWork
                )
            )
            .map(el => el.title)
        } else {
          params.push(title)
        }
      }
    })

    return params.join(',')
  }

  get body() {
    console.log('bodyParams', this.bodyParams)

    if (this.queryParams.active === EnumTongHaoStatus.FenTong) {
      return {
        sourceId: this.hasJoin ? this.GuildStore.joinedCity?.id : undefined,
        sourceType: MomentSourceType.Guild
      }
    }

    return {
      sourceId: this.queryParams.active === EnumTongHaoStatus.FenTong && this.hasJoin ? this.GuildStore.joinedCity?.id : undefined,
      firstRequestTime: this.requestTime,
      topics: this.queryParams.active === EnumTongHaoStatus.Follow ? undefined : this.bodyParams, // 关注页不传topics参数
      active: this.queryParams.active
    }
  }

  get pagePagination() {
    return this.PageStore.pagePagination
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  get PageStore() {
    return this.$store.$tonghao
  }

  get tabs() {
    return dataSource_tonghaoV2
  }

  // 获取动态高度
  getComptedHeightList(list) {
    return this.toJS(list).map(item => {
      let totalHeight: number = 0

      // 计算图片高度
      totalHeight +=
        Array.isArray(this.toJS(item.pictures)) && item.pictures.length > 0
          ? this.getImageHeight(item.pictures[0].originWidth, item.pictures[0].originHeight)
          : 248
      // 计算 title 间距
      totalHeight += item.sourceDescription ? 8 : 10
      // 计算 title 高度，如果超过200（一行文字宽度），则高度为36，否则为18
      totalHeight += (this.getTextWidth(item.title || item.content) ?? 0) > 200 ? 36 : 18
      // 计算 card-info 间距 + 高度 + 底部间距
      totalHeight += 12 + 28 + 12

      return {
        ...item,
        height: totalHeight
      }
    })
  }

  getTextWidth(text, font = '14px sans-serif') {
    if (!text) return null
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) return null
    ctx.font = font
    return ctx.measureText(text).width
  }

  compactImageSize(originWidth: number, originHeight: number) {
    const limitWidth = 194
    const shouldHeigth = Math.floor((limitWidth * originHeight) / originWidth)

    return [limitWidth, shouldHeigth]
  }

  getImageHeight(originWidth: number, originHeight: number) {
    return Math.max(100, Math.min(248, this.compactImageSize(originWidth, originHeight)[1]))
  }

  handleClosed() {
    if (this.needLogin) {
      this.$store.$storeUser.onToggleVisible(true)
      this.needLogin = false
    }
  }

  handleOpenLogin() {
    this.needLogin = true
    this.userContentPop.hidePop()
  }

  // 弹窗内部删除事件
  handleRemoveSuccess(data: { type: 'dairy'; momentId: string }) {
    if (data.type === 'dairy' && data.momentId) {
      // 删除缓存的数据
      this.PageStore.removeItem(data.momentId)
    }
  }

  // 弹窗内部收藏事件
  handleLikeSuccess(data: { momentId: string }) {
    if (data.momentId) {
      this.PageStore.likeItem(data.momentId)
    }
  }

  // 卡片点击事件
  handleClickMoment(momentId: string) {
    if (!momentId) return

    this.userContentPop?.showPop({
      type: 'dairy',
      momentId
    })
  }

  // 卡片点赞事件
  @Debounce(350, { leading: true, trailing: false })
  @Bind()
  async handleLikeMoment(item: Moment) {
    // 未登录防御
    if (!this.UserInfo.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    try {
      await this.PageStore.onLikeMoment(item)
      this.$message.success('点赞成功')
    } catch (e) {
      if (e instanceof Error) {
        this.$message.error(e.message)
      }
    }
  }

  handleChangeTab(params: Partial<QueryParams>) {
    if (lodash.isEqual(this.queryParams, params)) return

    // 默认展示的是该用户加入的分桐详情
    if (this.hasJoin && params.active === EnumTongHaoStatus.FenTong) {
      this.openImproveModal()
    }

    this.queryParams = {
      ...this.queryParams,
      ...params
    }

    this.PageStore.mapPagePagination(this.queryParams.active as EnumTongHaoStatus)

    // 切换tab数据清空 + 缓存
    this.PageStore.pagePagination.clearData(this.body)

    if (!lodash.isEqual(this.$route.query, this.PageStore.toSearchQuery(this.queryParams))) {
      this.$router.replace({ query: this.PageStore.toSearchQuery(this.queryParams) })
    }

    // 根据是否显示推荐城市模块，调整切换tab时的向上滚动距离
    window.scrollTo({
      top: !this.showRecommend === true ? 0 : 926,
      behavior: 'smooth'
    })
  }

  hideRecommendCities: boolean = false
  hideLocationTip: boolean = false

  hasJoin: boolean
  isManager: boolean // 是否为当前分桐管理员
  hasLocalPermission: boolean = false
  guildDetail: GuildDetail

  guildOptions = {
    type: 'guild',
    showBackButton: false,
    contentRequired: false,
    imageRequired: true,
    maxImageSize: 9,
    editorTitle: '日常内容',
    uploaderTitle: '添加图片',
    contentPlaceholder: '在这里，可以聊聊日常练习，分享学习感悟，或是讲讲其他趣事。'
  }

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => Promise<boolean>
  }
  @Ref()
  congratulateModal: {
    show: (options?: CongratulateModalData) => void
  }
  @Ref()
  editor?: {
    getFormStatus(): { hasImage: boolean; hasContent: boolean; hasTitle: boolean }
  }
  @Ref()
  popLayout: {
    open: () => void
    hide: () => void
  }
  ob: IntersectionObserver | null = null
  showBackToTop: boolean = false

  get EnumCityStatus() {
    return EnumCityStatus
  }

  get showIntroPanel() {
    return this.hasJoin && this.queryParams.active === EnumTongHaoStatus.FenTong
  }
  get showRecommend() {
    return !this.hideRecommendCities && !this.hasJoin
  }
  get GuildStore() {
    return this.$store.$tonghao.Guild
  }
  get TabList() {
    const isLogin = !!this.UserInfo.id
    const { Follow, FenTong } = EnumTongHaoStatus

    return this.tabs.filter(item => {
      // 未登录不显示 - 关注
      if (!isLogin) return ![Follow, FenTong].includes(item.key as EnumTongHaoStatus)
      // 已登录，关闭分桐的情况下则显示；未关闭不显示 - 分桐
      return this.hasJoin === true || item.key !== FenTong || this.hideRecommendCities
    })
  }

  handleClickBackToTop() {
    const el2 = document.getElementById('page-scroll-target-two')
    const { el1: el1Visible, el2: el2Visible } = elVisible

    if (!el2) return

    if (!el2Visible) {
      el2.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })

      return
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  handleWriteDairy() {
    this.popLayout.open()
  }

  handleSuccess({ payload }: { payload: WaterfallMoment }) {
    this.popLayout.hide()

    // 将新的日记插入到瀑布流[发现]第一个位置处
    const oldList = [...this.toJS(this.pagePagination.dataSource)]
    const newList = [payload, ...oldList]
    this.pagePagination.updateSource(newList)
  }

  handleClickWriteDairyOutside() {
    if (this.editor) {
      const { hasContent, hasImage, hasTitle } = this.editor.getFormStatus()

      if (hasContent || hasImage || hasTitle) {
        this.$confirmV2({
          desc: '你的日记还未提交',
          okText: '坚持离开',
          cancelText: '取消',
          clickToClose: false,
          onOk: () => {
            this.popLayout.hide()
          },
          onException: () => {
            this.popLayout.hide()
          }
        })
        return
      }
    }

    this.popLayout.hide()
  }

  getHideWaterfall(data: CityTypeInfo | null) {
    if (!data) return true

    if (data.status === EnumCityStatus.Inited) return false

    if (data.recruitStatus === true) {
      return EnumStatus.Recruit
    }

    if (data.status === EnumCityStatus.Assistance) {
      return !this.hasJoin ? EnumStatus.Assistance : EnumStatus.Share
    }

    return false
  }

  handleHideImproveModal() {
    localStorage.setItem(dataSource_hide_store_key.hideImproveModalStoreKey, 'true')
  }

  checkShowLocationTip() {
    if (!this.UserInfo.id) return

    if (!!localStorage.getItem(dataSource_hide_store_key.hideLocationTipStoreKey) === true) {
      this.hideLocationTip = true
    }
  }

  handleHideLocationTip() {
    if (!this.UserInfo.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    this.hideLocationTip = true

    localStorage.setItem(dataSource_hide_store_key.hideLocationTipStoreKey, 'true')
  }

  checkShowRecommendCities() {
    if (!this.UserInfo.id) return

    if (!!localStorage.getItem(dataSource_hide_store_key.hideCitiesStoreKey) === true) {
      this.hideRecommendCities = true
    }
  }

  // 关闭桐学会模块二次确认
  async onCloseGuildModuleConfirmModal() {
    if (!this.UserInfo.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    const res = await this.confirmModal.show({
      description: `关闭后可在下方桐学会分类中查看分桐`,
      layoutClassName: 'close-guild-module-confirm-modal',
      confirmedHide: true,
      confirmText: '关闭',
      cancelText: '取消'
    })

    if (res === true) {
      this.hideRecommendCities = true
      localStorage.setItem(dataSource_hide_store_key.hideCitiesStoreKey, 'true')
    }
  }

  // 完善个人信息弹窗
  async openImproveModal() {
    if (!this.UserInfo.id) return

    if (!!localStorage.getItem(dataSource_hide_store_key.hideImproveModalStoreKey) === true) return

    const result: string[] = []

    if (!this.UserInfo.phoneNum) {
      result.push(`·填写手机号，方便分桐负责人联络\n`)
    }

    if (!this.UserInfo.summary) {
      result.push(`·完善个人简介，让大家更快认识你\n`)
    }

    if (!this.UserInfo.specialty) {
      result.push(`·简单介绍自己，聊聊你的兴趣爱好吧~`)
    }

    if (!result.length) return

    this.handleHideImproveModal()

    const res = await this.confirmModal.show({
      title: `完善个人信息`,
      description: result.join(''),
      layoutClassName: 'improve-confirm-modal',
      confirmedHide: true,
      confirmText: '去完善',
      cancelText: '取消'
    })

    if (res === true) {
      this.$router.push('/my/settings')
    }
  }

  onJoinFail() {
    this.confirmModal.show({
      title: `还不能加入哦~`,
      description: '仅限报名过林曦老师亲授的直播课程，或是林曦老师监制的教练日课的桐学方可申请加入。',
      layoutClassName: 'join-fail-confirm-modal',
      confirmedHide: true,
      confirmText: '确认',
      hideCancel: true
    })
  }

  onJoinSuccess() {
    this.$msg('加入成功~', 'success')

    setTimeout(() => {
      location.reload()
    }, 200)
  }
  async openAssistantModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `为${data.cityName}分桐助力`,
      description: `助力成功后将自动加入${data.cityName}分桐，我们会选取热力值最高的1-2个城市，优先推动分桐开放。`,
      layoutClassName: 'assistant-confirm-modal',
      confirmedHide: true,
      confirmText: '立即助力',
      cancelText: '稍后再说',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/assistant-pop-bg.png'
    })
    if (res === true) {
      const res = await this.GuildStore.joinGuild(data.id)
      if (res === EnumJoinResponseType.Success) {
        this.onJoinSuccess()
      } else if (res === EnumJoinResponseType.NoAuth) {
        this.onJoinFail()
      }
    }
  }
  async openRecruitModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `成为${data.cityName}分桐负责人`,
      description: `报名参与负责人招募，即视为您已自动加入该分桐。待负责人招募工作全部完成后，${data.cityName}分桐将正式开放。`,
      layoutClassName: 'recruit-confirm-modal',
      confirmedHide: true,
      confirmText: '确认',
      cancelText: '再想想',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/recruit-pop-bg.png'
    })

    if (res === true) {
      const res = await this.GuildStore.joinGuild(data.id)
      if (res === EnumJoinResponseType.Success) {
        this.onJoinSuccess()
      } else if (res === EnumJoinResponseType.NoAuth) {
        this.onJoinFail()
      }
    }
  }
  async openJoinModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `${data.cityName}分桐`,
      description: '桐学仅可选择一座常住城市加入，与桐好笔墨相伴，雅会常聚。',
      layoutClassName: 'join-confirm-modal',
      confirmedHide: true,
      confirmText: '确认加入',
      cancelText: '再想想',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/assistant-pop-bg.png'
    })

    if (res === true) {
      const res = await this.GuildStore.joinGuild(data.id)
      if (res === EnumJoinResponseType.Success) {
        this.onJoinSuccess()
      } else if (res === EnumJoinResponseType.NoAuth) {
        this.onJoinFail()
      }
    }
  }

  refreshPage() {
    location.reload()
  }

  updateGuildOptions() {
    if (!this.guildDetail) return
    this.guildOptions['guildId'] = this.guildDetail.id
  }

  showCongratulateModal(data: ModalDataType) {
    // this.congratulateModal.show({
    //   type: CongratulateType.Init,
    //   bgPath: 'congratulate-init',
    //   cityName: data.cityName
    // })

    this.congratulateModal.show({
      type: CongratulateType.Recruit,
      bgPath: 'congratulate-recruit',
      cityName: data.cityName
    })
  }
  async initCities(location?: UserLocationInfo) {
    if (location && location.cityCode) {
      this.PageStore.Guild.getLocateRecommendCities(location.cityCode.toString())
    }
    this.PageStore.Guild.getRecommendCities()
  }

  async initLocation() {
    if (!this.UserInfo.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    const location = await getUserLocation()

    if (!location) return

    this.initCities(location)

    this.hideLocationTip = true
  }

  async init() {
    this.checkShowRecommendCities()
    this.checkShowLocationTip()

    // 检查是否已经获取到定位授权
    this.hasLocalPermission = await checkLocationPermission()

    if (this.hasLocalPermission && !!this.UserInfo.id) {
      this.initLocation()
      return
    }

    this.initCities()
  }

  created(): void {
    this.PageStore.mapPagePagination(this.queryParams.active as EnumTongHaoStatus)
    this.init()
    this.updateGuildOptions()
  }

  mounted() {
    // 刷新进入检测
    if (this.hasJoin && this.queryParams.active === EnumTongHaoStatus.FenTong) {
      this.openImproveModal()
    }

    const el1 = document.getElementById('page-scroll-target-one')
    const el2 = document.getElementById('page-scroll-target-two')
    if (el1 && el2 && !this.ob) {
      this.ob = new IntersectionObserver(
        entities => {
          entities.forEach(entity => {
            if (entity.target === el1) {
              elVisible.el1 = entity.isIntersecting
              this.showBackToTop = entity.isIntersecting === false && entity.boundingClientRect.top < 0
            } else if (entity.target === el2) {
              elVisible.el2 = entity.isIntersecting
            }
          })
        },
        {
          threshold: [0, 1]
        }
      )

      this.ob.observe(el1)
      this.ob.observe(el2)
    }
  }

  updated(): void {}

  destroyed(): void {
    if (this.ob) {
      this.ob.disconnect()
    }
  }
}
